import { useCookies } from 'react-cookie';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getAnalytics, setUserProperties } from 'firebase/analytics';

/**
 * A custom hook for changing the language of the application based on user interaction.
 * @returns function
 */
function useChangeLanguage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const [, setCookie] = useCookies(['language']);
  const analytics = getAnalytics();

  function changeLanguage(language) {
    if (lang !== language) {
      setUserProperties(analytics, { language });
      // This is the one legitimate place to persist the user's preference:
      // an explicit selection. useLangParam intentionally does NOT write
      // the cookie just from viewing a URL, so it has to happen here.
      setCookie('language', language, { path: '/' });

      const currentUrl = location.pathname;
      let newUrl =
        currentUrl.length > 3
          ? currentUrl.replace(`/${lang}/`, `/${language}/`)
          : currentUrl.replace(`/${lang}`, `/${language}`);
      navigate(newUrl, { relative: false });
    }
  }

  return changeLanguage;
}
export default useChangeLanguage;
